import React, {useState, useEffect} from 'react';
import {
  Dialog,
  DialogHeader,
  DialogContent,
  Button,
  Theme,
  DialogFooter,
} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import {useUiState} from '../../../Context/UserInterface/UserInterfaceContext';

export type AssistantFlightCheckProps = {
  isOpen: boolean;
  onContinueInEditor: () => void;
};

const AssistantFlightCheck = ({isOpen, onContinueInEditor}: AssistantFlightCheckProps) => {
  const {t} = useTranslation(['toolpalette', 'flightcheck']);

  const ui = useUiState();

  const [reviewAcceptChecked, setReviewAndAcceptChecked] = useState<boolean>(false);

  useEffect(() => {
    if (reviewAcceptChecked) {
      setReviewAndAcceptChecked(false);
    }
  }, [isOpen]);

  return (
    <Dialog
      id={'assistant-flightcheck-dialog'}
      open={isOpen}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      width={500}
      title={t('flightcheck:str_MessagePleaseReviewProject')}
    >
      <DialogContent>
        <Theme element={'p'} className={'mb-md'}>
          {t('flightcheck:str_MessageIssuesInProjectWarning')}
        </Theme>
      </DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button
          buttonStyle={'primary'}
          label={t('flightcheck:str_LabelReviewIssues')}
          size={'small'}
          onClick={() => {
            onContinueInEditor();
          }}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default AssistantFlightCheck;
